import AppText from "../../design-system/components/AppText";
import AppToolbar from "../../design-system/components/AppToolbar";
import AppTooltip from "../../design-system/components/AppTooltip";
import { IconInfo } from "../../design-system/icons";

/*
  Abschnittsueberschrift der Verfuegbarkeits-Oberflaechen: Titel, optionaler
  Info-Tooltip und rechts Platz fuer eine Aktion.

  Einmal definiert, damit Einstellungs-Dialog, Mitarbeiter-Dialog und das
  Erfassungs-Panel dieselben Abstaende und Groessen tragen.
*/
export default function AvailabilitySectionTitle({ title, info, infoLabel, action = null }) {
  return (
    <AppToolbar
      className="availability-section-title"
      left={(
        <>
          <AppText as="h3" variant="heading-4">
            {title}
          </AppText>
          {info ? (
            <AppTooltip content={info}>
              <IconInfo
                className="availability-section-title__info"
                aria-label={infoLabel || info}
              />
            </AppTooltip>
          ) : null}
        </>
      )}
      right={action}
    />
  );
}
